<template>
  <div class="page desktop-login flex-col">
    <div class="group_1 flex-col">

      <div class="text-wrapper_1 flex-col">
        <span class="text_2">用户登录</span>
      </div>
      <div class="group_3 flex-col"><div class="box_1 flex-col"></div></div>
      <div class="group_4 flex-row">
        <div class="image-text_1 flex-row justify-between">
          <div class="section_1 flex-col">
            <div class="group_5 flex-col"></div>
          </div>
          <span class="text-group_1">云手机异地签到，AI 周报日报月报独立 ip，100%安全，接的YF平台</span>
        </div>
      </div>
      <!-- 用户名输入框 -->
      <div class="text-wrapper_2 flex-col">
        <van-field
          v-model="username"
          class="input-field"
          placeholder="请输入用户名"
          clearable
          @keyup.enter="login"
        />
      </div>
    </div>
    <div class="group_6 flex-col">
      <!-- 密码输入框 -->
      <div class="text-wrapper_3 flex-col">
        <van-field
          v-model="password"
          class="input-field"
          type="password"
          placeholder="请输入密码"
          clearable
          @keyup.enter="login"
        />
      </div>
      <!-- 验证码输入框 -->
      <div class="captcha-container flex-row">
        <div class="text-wrapper_captcha flex-col">
          <van-field
            v-model="captcha"
            class="input-field"
            placeholder="请输入验证码"
            clearable
            maxlength="4"
            @keyup.enter="login"
          />
        </div>
        <div class="captcha-image" @click="refreshCaptcha">
          <img v-if="captchaImage" :src="captchaImage" alt="验证码" />
          <div v-else class="captcha-placeholder">点击获取</div>
        </div>
      </div>
      <!-- 登录按钮 -->
      <div class="text-wrapper_4 flex-col" @click="login">
        <span class="text_5" v-if="!loading">登录</span>
        <span class="text_5" v-else>登录中...</span>
      </div>
      <span class="text_6" @click="register">用户注册</span>
      <div class="kefu-line" @click="contactKefu">{{ kefuText }}</div>
      <div class="group_7 flex-row justify-between">
        <div class="box_2 flex-col" @click="toggleAgreement">
          <div class="box_3 flex-col" v-if="agreeTerms"></div>
        </div>
        <span class="text_7">登录/注册即代表您同意《用户协议》</span>
      </div>
      <!-- <div class="group_8 flex-col" v-if="agreeTerms">
        <div class="section_2 flex-col"></div>
        <div class="section_3 flex-col"></div>
      </div> -->
    </div>
    <!-- <van-toast v-model="showToast" :message="toastMsg" /> -->
  </div>
</template>
<script>
import axios from 'axios'
import { Field } from 'vant'
import CryptoJS from 'crypto-js'
import { API_ENDPOINTS } from '@/config/api'

// 后台未配置 qq 时的兜底客服
const DEFAULT_KEFU_CONTACT = '3474659718'

export default {
  components: {
    'van-field': Field
  },
  data() {
    return {
      username: '',
      password: '',
      captcha: '',
      captchaImage: '',
      captchaId: '',
      loading: false,
      agreeTerms: true,
      kefuContact: DEFAULT_KEFU_CONTACT
    };
  },
  computed: {
    kefuText() {
      const raw = (this.kefuContact || '').trim();
      return /^\d{5,12}$/.test(raw) ? `客服QQ：${raw}` : raw;
    }
  },
  async mounted() {
    await this.refreshCaptcha();
    this.loadKefuContact();
  },
  methods: {
    // 读取后台客服配置；失败时保留兜底联系方式
    async loadKefuContact() {
      try {
        const res = await axios.get(API_ENDPOINTS.SETTING.GET_SETTING, {
          params: { key: 'qq' }
        });
        const raw = (res.data && res.data.code === 0 && res.data.data)
          ? String(res.data.data).trim()
          : '';
        if (raw) {
          this.kefuContact = raw;
        }
      } catch (error) {
        console.error('获取客服联系方式失败:', error);
      }
    },
    contactKefu() {
      const raw = (this.kefuContact || '').trim();
      if (/^\d{5,12}$/.test(raw)) {
        window.open(`https://wpa.qq.com/msgrd?v=3&uin=${raw}&site=qq&menu=yes`);
      } else if (raw) {
        this.showToastMsg(raw);
      }
    },
    async login() {
      if (!this.username || !this.password) {
        this.showToastMsg('请输入用户名和密码');
        return;
      }
      
      // if (!this.captcha) {
      //   this.showToastMsg('请输入验证码');
      //   return;
      // }
      
      if (!this.agreeTerms) {
        this.showToastMsg('请先同意用户协议');
        return;
      }
      
      this.loading = true;
      try {
        // 对密码进行MD5加密
        const encryptedPassword = CryptoJS.MD5(this.password).toString();
        
        const res = await axios.post(API_ENDPOINTS.AUTH.LOGIN, {
          username: this.username,
          password: encryptedPassword,
          selectAccount: '',
          captcha: this.captcha,
          captchaId: this.captchaId
        });
        
        if (res.data.code === 0) {
          const token = res.data.data.accessToken;
          if (token) {
            localStorage.setItem('token', token);
            this.showToastMsg('登录成功');
            // 获取并显示登录公告
            await this.showLoginNotice();
            // 延迟跳转，让用户看到成功提示
            setTimeout(() => {
              this.$router.push('/shouye');
            }, 1500);
          } else {
            this.showToastMsg('登录失败：未获取到token');
          }
        } else {
          // 根据错误码显示不同的错误信息
          let errorMsg = '登录失败';
          switch (res.data.code) {
            case 4001:
              errorMsg = '用户名未找到';
              break;
            case 4002:
              errorMsg = '密码错误';
              break;
            case 4003:
              errorMsg = '验证码错误';
              break;
            default:
              errorMsg = res.data.message || '登录失败';
          }
          this.showToastMsg(errorMsg);
          // 验证码错误时刷新验证码
          if (res.data.code === 4003) {
            await this.refreshCaptcha();
            this.captcha = '';
          }
        }
      } catch (error) {
        console.error('登录失败:', error);
        if (error.response) {
          this.showToastMsg(`网络错误: ${error.response.status}`);
        } else if (error.request) {
          this.showToastMsg('网络连接失败，请检查网络');
        } else {
          this.showToastMsg('登录失败，请重试');
        }
        // 登录失败时刷新验证码
        await this.refreshCaptcha();
        this.captcha = '';
      } finally {
        this.loading = false;
      }
    },
    
    // 跳转到注册页面
    register() {
      this.$router.push('/register');
    },
    
    toggleAgreement() {
      this.agreeTerms = !this.agreeTerms;
    },
    showToastMsg(msg) {
      this.$toast(msg);
    },
    
    // 获取验证码
    async refreshCaptcha() {
      try {
        const res = await axios.get(API_ENDPOINTS.AUTH.CAPTCHA);
        if (res.data.code === 0) {
          this.captchaImage = res.data.data.image;
          this.captchaId = res.data.data.id;
        } else {
          this.showToastMsg('获取验证码失败');
        }
      } catch (error) {
        console.error('获取验证码失败:', error);
        this.showToastMsg('获取验证码失败，请重试');
      }
    },

    // 显示登录公告
    async showLoginNotice() {
      try {
        const res = await axios.post(API_ENDPOINTS.SETTING.GET_SETTING, {
          key: 'login_notice'
        });

        if (res.data.code === 0 && res.data.data && res.data.data.trim()) {
          // 使用vant的Dialog显示公告
          this.$dialog.alert({
            title: '系统公告',
            message: res.data.data,
            confirmButtonText: '我知道了',
            confirmButtonColor: '#007bff'
          });
        }
      } catch (error) {
        console.error('获取登录公告失败:', error);
      }
    }
  }
};
</script>
<style scoped lang="css" src="./assets/lanhu-style.css" />

<style>
.kefu-line {
  margin-top: 12px;
  color: #00a85a;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
</style>
